import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Çeviri dosyalarını import et
import translationEN from './locales/en/translation.json';
import translationTR from './locales/tr/translation.json';
import translationDE from './locales/de/translation.json';
import translationES from './locales/es/translation.json';
import translationFR from './locales/fr/translation.json';
import translationIT from './locales/it/translation.json';

const resources = {
  en: { translation: translationEN },
  tr: { translation: translationTR },
  de: { translation: translationDE },
  es: { translation: translationES },
  fr: { translation: translationFR },
  it: { translation: translationIT },
};

i18n
  .use(LanguageDetector) // Tarayıcı dilini algılar
  .use(initReactI18next) // i18n'i react'a bağlar
  .init({
    resources,
    fallbackLng: 'en', // Eğer seçilen dilin çevirisi yoksa İngilizce'yi kullan
    interpolation: {
      escapeValue: false, // React zaten XSS'e karşı koruma sağlıyor
    },
    detection: {
      order: ['localStorage', 'navigator'], // Önce local storage'a, sonra tarayıcı diline bak
    }
  });

export default i18n;